import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

export class SubPage {
  public title: string;
  public id: string;
  public selected: boolean;
  public form: FormGroup;
}

@Component({
    selector: 'app-sub-page-nav',
    templateUrl: './sub-page-navigation.component.html',
    styleUrls: ['./sub-page-navigation.component.scss'],
    standalone: false
})
export class SubPageNavigationComponent {
  @Input() public subPages: SubPage[];
  @Input() public disabled = false;
  @Output() public subPageLinkClick = new EventEmitter<string>();

  public togglePanel(panel: string): void {
    this.subPageLinkClick.emit(panel);
  }
}
